export default {
    language: 'pt-BR',
    list:{
        'pt-BR':{
            'quota': 'cota',
            'weak': 'fraca',
            'strong': 'forte',
            'moderate': 'moderada',
            'no data': 'sem dado',
            'minute': 'minuto',
            'day': 'dia',
            'month': 'mês',
            'ok': 'ok',
            'record_reading': 'leitura da medição',
            'task': 'tarefa',
            'reading': 'leitura',
            'reading_could_not_be_performed': 'leitura não pode ser feita',
            'ruler_reading': 'leitura da régua',
            'reading_hour': 'horário leitura',
            'details': 'detalhes',
            'description': 'descrição',
            'general_informations': 'informações gerais',
            'register_rrnn': 'registrar rrnn',
            'informations': 'informações',
            'register': 'registrar',
            'value': 'valor',
            'hour': 'hora',
            'lifit_section': 'levantamento de seção',
            'level_section': 'nivelamento de seção',
            'flow_measurement': 'medição de vazão',
            "water_level": "Nível d'água",
            'stealth': 'esconsidade',
            'stealth_angle': 'grau esconsidade',
            'speed': 'velocidade',
            'flow': 'vazão',
            'equation': 'equação',
            'station_prefix': 'posto',
            'transmission_status': 'status da transmissão',
            'reference_values': 'valores de referência',
            'general_params': 'parâmetros gerais',
            'general': 'geral',
            'location': 'localização',
            'status': 'status',
            'validity': 'validade',
            'limits': 'limites',
            'extravasation': 'extravasamento',
            'level': 'nível',
            'rain': 'chuva',
            'top': 'superior',
            'bottom': 'inferior',
            'attention': 'atenção',
            'emergency': 'emergência',
            'alert': 'alerta',
            'scarcity': 'escassez',
            'state': 'estado',
            'city': 'município',
            'q95': 'vazão natural',
            'oxygen': 'oxigênio',
            'temp': 'temperatura',
            'turbidity': 'turbidez',
            'conductivity': 'condutividade'
        }
    },
    t(text){
        return this.list[this.language][text] || 'Sem tradução encontrada para "' + text + '"'
    }
}